import {OnTimeSubmissionReport} from '../../../../models/enhancement/on-time-submission-report'
import {PeriodType} from '../../PeriodTypeSelector'

export function processChartData(data: OnTimeSubmissionReport, periodType: PeriodType = PeriodType.MONTH) {
  let originalLabels: string[]
  let actualValues: (number | null)[]

  if (periodType === PeriodType.PAY_PERIOD) {
    if (!data.payPeriodOnTimeSubmissionPercentage.length) {
      return {
        labels: [],
        actualValues: [],
        targetValues: []
      }
    }
    originalLabels = data.payPeriodOnTimeSubmissionPercentage.map(point => point.label)
    actualValues = data.payPeriodOnTimeSubmissionPercentage.map(point => point.value)
  } else {
    if (!data.monthlyOnTimeSubmissionPercentage.length) {
      return {
        labels: [],
        actualValues: [],
        targetValues: []
      }
    }
    originalLabels = data.monthlyOnTimeSubmissionPercentage.map(point => point.label)
    actualValues = data.monthlyOnTimeSubmissionPercentage.map(point => point.value)
  }
  const targetValues = Array(originalLabels.length).fill(95)

  return {
    labels: originalLabels,
    actualValues,
    targetValues
  }
}